<div class="app-page">
    <router-outlet></router-outlet>
</div>